import React, { useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import InfoIcon from '@mui/icons-material/Info';

import { getNumberComma } from '../../../utils/numberUtils';

const CostCalcRow = ({ cost, index }) => {
  const [toggleDesc, setToggleDesc] = useState(false);
  const handleToggleDesc = () => {
    setToggleDesc((prev) => !prev);
  };

  // 마스터 타입 체크 변수
  const isBal = cost?.masterTyp === 'BAL';

  return (
    <>
      <TableRow
        key={index}
        sx={{ 
          '& .MuiTableCell-root': { 
            fontSize: '0.875rem', 
            padding: '8px 4px', 
            textAlign: 'center',
            verticalAlign: 'middle' 
          },
          '& .MuiInputBase-root': {
            fontSize: '0.875rem',
            margin: '0 auto',
            marginTop: 0, 
          },
          '& .MuiInputBase-input': { 
            padding: '2px 0 3px 0', 
            textAlign: 'center' 
          },
          '& .MuiFormHelperText-root': {
            position: 'absolute',
            bottom: '-18px',
            margin: 0,
            fontSize: '0.65rem',
            whiteSpace: 'nowrap'
          },
          '& .MuiIconButton-root': { p: '4px' },
          '& .number-cell': { 
            textAlign: 'right',
            fontVariantNumeric: 'tabular-nums' 
          },
        }}   
      >
      <TableCell rowSpan={toggleDesc ? 2 : 1}>
        {index + 1}
        {/* masterTyp이 'N'이 아니고, 동시에 'BAL'도 아닐 때만 별표(*) 표시 */}
        {cost?.masterTyp !== 'N' && cost?.masterTyp !== 'BAL' && (
          <Typography variant="h6" color="error.main" component="span">
            *
          </Typography>
        )}
      </TableCell>
            
        <TableCell
          sx={{
            padding: '8px 12px', 
            position: 'relative',
            textAlign: 'left !important',
            height: '32px',             
            paddingY: 0,                
            whiteSpace: 'nowrap',       
            overflow: 'hidden',         
            textOverflow: 'ellipsis',   
          }}
        >
          {cost.productNm}
        </TableCell>

        {/* [수정] BAL일 경우 사양보기 아이콘 제외 */}
        <TableCell sx={{ width: 60, textAlign: 'center' }}>
          {!isBal && (
            <IconButton aria-label="사양보기" onClick={handleToggleDesc}>
              <InfoIcon />
            </IconButton>
          )}
        </TableCell>

        <TableCell sx={{ width: 80, textAlign: 'right' }}>
          {isBal ? '' : getNumberComma(cost.expCnt)}
        </TableCell>
        <TableCell>
          {cost.productUnit}
        </TableCell>
        <TableCell sx={{position: 'relative', textAlign: 'right !important'}}>
          {getNumberComma(cost.unitVal)}
        </TableCell>
        <TableCell sx={{position: 'relative', textAlign: 'right !important', backgroundColor: '#f9f9f9'}}>
          {getNumberComma(cost.saleVal)}    
        </TableCell> 
        <TableCell sx={{position: 'relative', textAlign: 'right !important', backgroundColor: '#f9f9f9'}}>
          {getNumberComma(cost.saleValIn)}
        </TableCell>

        <TableCell sx={{position: 'relative', textAlign: 'right !important'}}>
          {getNumberComma(cost.priceVal)}
        </TableCell>
        <TableCell sx={{position: 'relative', textAlign: 'right !important', backgroundColor: '#f9f9f9'}}>
          {getNumberComma(cost.buyVal)}
        </TableCell>
         <TableCell sx={{position: 'relative', textAlign: 'right !important', backgroundColor: '#f9f9f9'}}>
          {getNumberComma(cost.priceValIn)}
        </TableCell>

        {/* [수정] BAL일 경우 이익 제외 */}
        <TableCell sx={{position: 'relative', textAlign: 'right !important'}}>
          {getNumberComma(cost.saleProfit)}
        </TableCell>

        {/* [수정] BAL일 경우 이익률 제외 */}
        <TableCell sx={{ width: 80 , backgroundColor: '#f9f9f9'}}>
          {isBal ? '' : `${Number(cost.salePct).toFixed(2)} %`}
        </TableCell>

        <TableCell>{cost.itemCd}</TableCell>
        <TableCell>{cost.sellPartnerNm}</TableCell>
      </TableRow>

      {toggleDesc && (
        <TableRow>
          <TableCell colSpan={12} sx={{ py: 2 }}>
            <Typography
              sx={{ whiteSpace: 'pre-line' }}
              variant="body2"
              component="div"
            >
              {cost?.productDesc !== '' ? cost?.productDesc : ''}
            </Typography>
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

export default CostCalcRow;
